import View from './View';

export { default as View, getLanguageScreenStyles } from './View';

export default View;
